import { Box, CssBaseline } from '@mui/material';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import SimpleBar from 'simplebar-react'; // ✅ you missed this import
import 'simplebar-react/dist/simplebar.min.css'; // ✅ required styling

import Navbar from './components/Navbar';

import Home from './pages/Home';
import About from './pages/About';
import Works from './pages/Services';
import Contact from './pages/Contact';

import { ThemeProvider, useThemeContext } from './context/ThemeContext';

function AppContent() {
  const { theme } = useThemeContext();

  return (
    <SimpleBar style={{ maxHeight: '100vh' }} autoHide={false}>
      <Router>
        <Box
          sx={{
            width: '100%',
            minHeight: '100vh',
            backgroundColor: theme.background, // ✅ Use theme background
            color: '#fff',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Navbar />
          <Box sx={{ flex: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Works />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Box>
        </Box>
      </Router>
    </SimpleBar>
  );
}

function App() {
  return (
    <ThemeProvider>
      <CssBaseline />
      <AppContent /> {/* Wrap content inside a component that uses the context */}
    </ThemeProvider>
  );
}

export default App;